module.exports = __webpack_public_path__ + "img/nearly_headless_nick.cd7b3f32.jpg";